<script>
    // import app from './stores/app';
    import localGeos from '../stores/localGeos';
    import {initApp} from "../lib/requests";
    import LocalGeosTree from "./LocalGeosTree.svelte";
    import ForeignGeosTree from "./ForeignGeosTree.svelte";
    import {GEO} from "../lib/constants";


    let loading = false;

    const initializeApplication = async () => {
        if ($localGeos.tree.length > 0) {
            return;
        }

        loading = true;

        const [err, res] = await initApp();

        if (err) {
            alert('error ' + err)
            return;
        }
        $localGeos.list = res.list;
        $localGeos.tree = res.tree;
        $localGeos.selected_id = res.last_selected_id;

        loading = false;
    }

    initializeApplication();
</script>

{#if (loading)}
    <div class="initializer">
        <div class="logo">
            <img src="/assets/images/logo.png" alt="logo"/>
        </div>
    </div>
{:else}
    <div class="row">
        <div class="col-md-6">
            <LocalGeosTree/>
        </div>
        <div class="col-md-6">
            <ForeignGeosTree source={GEO.GOLDEN_HOME}/>
        </div>
    </div>
{/if}